export default "__VITE_ASSET__6b62d8a6__"